"use strict";
/// <reference path="../../../../Trillium.UI/TypeScript/Models/Website/PartnerPodsComponentViewModel.tsx"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var PartnerItemPodComponent = /** @class */ (function (_super) {
    __extends(PartnerItemPodComponent, _super);
    function PartnerItemPodComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PartnerItemPodComponent.prototype.render = function () {
        return (react_1.default.createElement("div", { className: "col-sm-12 col-md-6 col-lg-4 d-flex align-items-stretch pb-20" },
            react_1.default.createElement("article", { className: "pod partner-pod card matchHeightClass", id: "partnerPod_" + this.props.UniqueKey },
                react_1.default.createElement("div", { className: "card-img-div" },
                    react_1.default.createElement("img", { className: "card-img-top", id: "partnerPodImg_" + this.props.UniqueKey, src: this.props.ImageUrl, alt: this.props.ImageAltText })),
                react_1.default.createElement("div", { className: "card-body" },
                    react_1.default.createElement("h4", { className: "card-title" }, this.props.Title),
                    react_1.default.createElement("a", { href: this.props.LinkUrl, className: "parter-link" }, this.props.LinkTitle)))));
    };
    return PartnerItemPodComponent;
}(react_1.Component));
exports.default = PartnerItemPodComponent;
